module.exports = __webpack_public_path__ + "static/media/kurt.8dc5bbb6.jpg";